var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1694_8732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8098 46.6428C37.6582 46.6428 46.4526 37.8484 46.4526 27C46.4526 16.1516 37.6582 7.35718 26.8098 7.35718C15.9614 7.35718 7.16699 16.1516 7.16699 27C7.16699 37.8484 15.9614 46.6428 26.8098 46.6428Z",
    stroke: "#7CAA74",
    strokeWidth: 1.6369,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.625 27H34.994",
    stroke: "#7CAA74",
    strokeWidth: 1.6369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8096 18.8155V35.1845",
    stroke: "#7CAA74",
    strokeWidth: 1.6369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1694_8732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.3809,
    height: 52.3809,
    fill: "white",
    transform: "translate(0.619141 0.80957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.570255b37be72429d79487617bb534dc.svg";
export { ForwardRef as ReactComponent };